import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationNotification } from '../../root/models/application-notification.model';

@Pipe({
    name: 'TranslationFormatterPipe',
    standalone: false
})
export class TranslationFormatterPipe implements PipeTransform {
    constructor() {}

    transform(property: string, concatValue: string = null): any {
        let translationKey = '';
        translationKey = property;
        if(concatValue && concatValue != ''){
            translationKey = concatValue + '.' + property;
        }
        return translationKey;
    }
}
